// extracted by mini-css-extract-plugin
module.exports = {"dialog":"dialog_dialog__2CiR7","fadein":"dialog_fadein__G1KPw","fadeout":"dialog_fadeout__eLIRp","closeButtonContainer":"dialog_closeButtonContainer__y8iSW"};